var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlateDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1061,
    height: 1076,
    viewBox: "0 0 1061 1076",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M535.861 538.578C782.045 579.469 1016.31 412.751 1059.68 164.837L1060.74 157.877L1053.82 156.823C830.113 117.483 615.145 250.406 543.695 460.304C547.693 238.628 391.004 40.4436 167.293 1.10318L160.38 0.0496601L159.319 7.01015C115.954 254.924 279.431 491.628 524.946 536.915C279.125 496.079 44.497 662.742 1.1315 910.656L0.0707495 917.617L6.9838 918.67C230.694 958.011 445.662 825.087 517.112 615.189C513.113 836.866 669.803 1035.05 893.514 1074.39L900.427 1075.44L901.488 1068.48C944.853 820.569 781.375 583.866 535.861 538.578ZM1044.84 169.324C999.683 404.595 776.078 562.441 541.257 525.156C586.419 289.886 810.024 132.039 1044.84 169.324ZM172.085 16.0777C405.733 61.0559 562.097 285.805 524.576 522.239C290.928 477.261 134.564 252.513 172.085 16.0777ZM16.0184 905.803C61.1799 670.532 284.421 512.63 519.606 549.971C474.444 785.241 251.203 943.143 16.0184 905.803ZM536.287 552.888C769.935 597.866 926.299 822.614 888.778 1059.05C655.13 1014.07 498.766 789.322 536.287 552.888Z",
    fill: "#B27D52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlateDecoration);
export default __webpack_public_path__ + "static/media/plate-decoration.d935528fc606a936ebaff6c6498644f3.svg";
export { ForwardRef as ReactComponent };